import { render, staticRenderFns } from "./InvoiceSection.vue?vue&type=template&id=08d9429d&"
import script from "./InvoiceSection.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports